import React, { useMemo } from "react";
import { FiTrendingUp } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { Line, LineChart, ResponsiveContainer } from "recharts";
import { useTheme } from "styled-components";
import { formatarMoeda } from "../../../utils/calculos";
import {
  CmdCard,
  CmdCardCta,
  CmdCardHeader,
  CmdCardMetric,
  CmdCardMetrics,
  CmdCardSub,
  CmdCardTitle,
  MetaBar,
  MetaFill,
  SparklineWrap,
} from "../styles";

function toneForMeta(pct) {
  if (pct == null) return "default";
  if (pct >= 0.9) return "success";
  if (pct >= 0.6) return "warning";
  return "danger";
}

export default function ThroughputCard({ throughput, historico, precosVisiveis }) {
  const navigate = useNavigate();
  const theme = useTheme();
  const ganho = throughput?.ganho ?? 0;
  const meta = throughput?.metaGanhoRS ?? 0;
  const pctMeta = throughput?.pctMetaGanho ?? null;

  const sparkData = useMemo(
    () =>
      (historico || []).map((entry) => ({
        label: entry.label,
        ganho: entry.ganho || 0,
      })),
    [historico]
  );

  const tone = toneForMeta(pctMeta);

  return (
    <CmdCard>
      <CmdCardHeader>
        <FiTrendingUp size={13} />
        <span>Throughput do mês</span>
      </CmdCardHeader>
      <CmdCardTitle>
        {precosVisiveis ? formatarMoeda(ganho) : "••••••"}
      </CmdCardTitle>
      {meta > 0 ? (
        <CmdCardSub>
          de {precosVisiveis ? formatarMoeda(meta) : "••••••"} (
          {pctMeta != null ? `${Math.round(pctMeta * 100)}%` : "—"})
        </CmdCardSub>
      ) : (
        <CmdCardSub>Meta de ganho não definida</CmdCardSub>
      )}
      {sparkData.length > 0 && (
        <SparklineWrap>
          <ResponsiveContainer width="100%" height="100%">
            <LineChart data={sparkData}>
              <Line
                type="monotone"
                dataKey="ganho"
                stroke={theme.accent}
                strokeWidth={2}
                dot={false}
                isAnimationActive={false}
              />
            </LineChart>
          </ResponsiveContainer>
        </SparklineWrap>
      )}
      {meta > 0 && pctMeta != null && (
        <MetaBar>
          <MetaFill $pct={pctMeta} $tone={tone} />
        </MetaBar>
      )}
      <CmdCardMetrics>
        <CmdCardMetric>
          <span>Entregues</span>
          <span>{throughput?.qtdEntregue ?? 0}</span>
        </CmdCardMetric>
        <CmdCardMetric>
          <span>Dias úteis restantes</span>
          <span>{throughput?.diasUteisRestantes ?? 0}</span>
        </CmdCardMetric>
      </CmdCardMetrics>
      <CmdCardCta type="button" onClick={() => navigate("/financeiro")}>
        Ver financeiro
      </CmdCardCta>
    </CmdCard>
  );
}
